export const invariant = ( message: string) => {
    throw new Error(message);
};
